module.exports = __webpack_public_path__ + "a40de5958fe71fde150347ecf53db5d8.MP3";